// Angular
import { Component, OnChanges, SimpleChanges, OnInit, Inject, input } from '@angular/core';

// NGRX
import { Store, select } from '@ngrx/store';

// OLCI
import * as fromRoot from '../../../reducers';
import * as tracking from '../../../actions/tracking';
import { BrowserUtils } from '../../../utils/browser.utils';
import { AnalyticsData } from '../../../models/analytics-data';
import { MobileAppLinks } from '../../../models/mobile-app-links';
import { BookingService } from '../../core/services/booking.service';
import {AnalyticsDataParamsInterface} from '../../../effects/interfaces';
import { AnalyticsService } from '../../core/services/analytics.services';
import { constants, CONSTANTS, analyticsConstants } from '../../../constants';

@Component({
    selector: 'app-mobile-app-banner',
    templateUrl: './modal-mobile-app.component.html',
    styleUrls: ['./modal-mobile-app.component.scss'],
    providers: [BrowserUtils],
    standalone: false
})
export class ModalMobileAppComponent implements OnInit, OnChanges {
	public readonly layoutState = input<string>();
	public readonly bundle = input<any>(null);
	public readonly screensize = input<any>({ isphone: false, isdesktop: true });

	public showMenu: boolean;
	public showMobileAppAdModal: boolean;
	public isRoyal: boolean;
	public isSafari: boolean;
	public mobileAppLinks: MobileAppLinks;
	public iosLink: string;
	public androidLink: string;
	public brand = '';
	public device: string;
	public isAppleDevice: boolean;
	public isAndroidDevice: boolean;
	public deepLinkUrl: string;

	private mobileAppLinksPayload: AnalyticsData | null;

	public constructor(
		private readonly store: Store<fromRoot.AppState>,
		@Inject('UrlService') public urlService: any,
		@Inject(CONSTANTS) public contents: any,
		private readonly bookingService: BookingService,
		private analyticsService: AnalyticsService,
		private browserUtils: BrowserUtils
	) {
		this.showMobileAppAdModal = false;
		this.isRoyal = false;
		store.pipe(select(fromRoot.getContentRetrieval)).subscribe(s => {
			this.isRoyal = s?.brandCode === 'R';
		});
	}

	ngOnInit(): void {
		if (navigator.userAgent.match(/Safari/) && !navigator.userAgent.match(/CriOS/) && !navigator.userAgent.match(/Chrome/)) {
			this.isSafari = true;
		}
		this.mobileAppLinksPayload = this.analyticsService.getAnalyticsDataForTracking(constants.APP_STORE_SOURCE_PAGE.MOBILE_AD_MODAL, constants.ANALYTICS_LOCATIONS.LANDING_PAGE_POPUP);

		this.mobileAppLinks = this.urlService.mobileAppLinks(this.mobileAppLinksPayload);
		this.brand = this.bookingService.getBrand();
		this.device = this.browserUtils.getDevice();
		this.isAppleDevice = this.device === constants.DEVICE_TYPE.IPHONE || this.device === constants.DEVICE_TYPE.IPAD;
		this.isAndroidDevice = this.device === constants.DEVICE_TYPE.ANDROID;
		this.deepLinkUrl = (constants.DEEP_LINK_APP_URL as any)[this.brand.toUpperCase()];
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes['layoutState']) {
			const layoutState = changes['layoutState'].currentValue;

			if (layoutState && layoutState.openedModalName === constants.MODAL.MOBILE_APP_BANNER) {
				this.showMobileAppAdModal = true;
				this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: mobile app ad: dialog opened'));
			} else if (layoutState && layoutState.openedModalName === 'close') {
				this.showMobileAppAdModal = false;
			}
		}
	}

	public closeModal(): void {
		this.showMobileAppAdModal = false;
		this.store.dispatch(new tracking.TrackPageInteractionEventAction('modal: mobile app ad: dialog closed'));
	}

	public formatLongHeader(): string {
		const bundle = this.bundle();
  if (!bundle || !bundle['app.modal.header']) {
			return '';
		}
		return bundle['app.modal.header']
			.replace('Check In', '<strong>Check In</strong>')
			.replace('Check in', '<strong>Check in</strong>')
			.replace(/\u00A0/g, ' ');
	}

	public formatShortHeader(): string {
		return this.formatLongHeader()
			.replace('Royal Caribbean', 'Royal')
			.replace('Celebrity Cruises', 'Celebrity')
			.replace(/\u00A0/g, ' ');
	}
	public formatSubTitle() {
		const bundle = this.bundle();
  if (!bundle || !bundle['app.modal.subheader']) {
			return '';
		}
		return bundle['app.modal.subheader'].replace('Expedited Arrival', '<strong>Expedited Arrival</strong>').replace(/\u00A0/g, ' ');
	}

	trackDeepLink(deviceStore: string) {
		const analyticsData: AnalyticsDataParamsInterface = {
      event: analyticsConstants.INTERACTION_EVENT_TYPE,
      interaction: `Store:${deviceStore}`,
      sourcePage: constants.APP_STORE_SOURCE_PAGE.MOBILE_AD_MODAL,
      ctaLocation: constants.ANALYTICS_LOCATIONS.LANDING_PAGE_POPUP
    };
    this.store.dispatch(new tracking.TrackFrontendDeepLinkEventAction(analyticsData));
	}

	isDesktop() {
		const screensize = this.screensize();
  return this.device === constants.DEVICE_TYPE.DESKTOP && screensize && screensize.isdesktop;
	}

	isMobile() {
		const screensize = this.screensize();
  return this.device === constants.DEVICE_TYPE.DESKTOP && screensize && !screensize.isdesktop;
	}
}
